export default __webpack_public_path__ + "static/Avenir-Medium-09-2f776cf995308eb67e81807e71891a67.woff";